import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation BulkDeleteResource($ids: [ID!]!) {
    bulkDeleteResources(ids: $ids) {
      id
    }
  }
`;

export const bulkDeleteResources = (ids) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { ids },
  }).then(({ data }) => getSingleProp(data));
};
